import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

// Liefert den Portal-Slug: aus der Route (/portal/:slug) ODER aus dem Custom-Domain-Kontext.
export const PortalDomainContext = createContext({ slug: null, customDomain: false });

export function usePortalSlug() {
  const { slug } = useParams();
  const ctx = useContext(PortalDomainContext);
  return slug || ctx.slug || null;
}

export function usePortalDomain() {
  return useContext(PortalDomainContext);
}
